import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../config/app-settings'
import { useGetTubeAggregateLinksByServiceIdQuery } from '../../redux/apis/linkManagement/tube/lMTubeApiSlice'
import { toast } from 'react-toastify'
import Loader from '../pages/loader'
import ReusableTable from '../../components/other/ReuseableTable'
import ServicesDropdown from '../../components/ServicesDropdown'

const TubeReviewing = React.memo(() => {
  const [selectedService, setSelectedService] = useState(null)
  const context = useContext(AppSettings)

  const { data, isLoading,isFetching, error, refetch } =
    useGetTubeAggregateLinksByServiceIdQuery(selectedService, {
      skip: !selectedService
    })

  // Service name mapping for URL construction
  const getServiceSlug = (serviceId) => {
    const serviceMap = {
      8: 'dailymotion',
      9: 'vimeo',
      11: 'okru'
    }
    return serviceMap[serviceId] || 'tube'
  }

  const columns = [
    {
      title: 'Campaign ID',
      dataIndex: 'campaign_id',
      key: 'campaign_id',

    },
    {
      title: 'CAMPAIGN NAME',
      dataIndex: 'campaign_name',
      key: 'campaign_name',
      search: true
    },
    {
      title: 'CUSTOMERS',
      dataIndex: 'customers',
      key: 'customers',
      search: true,
      render: (customers, record) => <>{customers?.map(x => x)?.join(', ')}</>
    },
    {
      title: 'SCREENSHOTS COUNT',
      dataIndex: 'to_review_count',
      key: 'to_review_count',
      search: true
    },
    {
      title: 'Actions',
      dataIndex: 'campaign_id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`/reviewing-screenshots/${getServiceSlug(selectedService)}/campaign/${record?.campaign_id}/${selectedService}`}
            className='btn btn-outline-theme'
          >
            Review
          </a>
        </div>
      )
    }
  ]

  useEffect(() => {
    console.log(error)
    if (error) {
      toast.error(error)
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refetch()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refetch])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      <div className='row mb-3'>
        <div className='col-md-4'>
          <ServicesDropdown
          label='Select the service to review'
            onChange={e => {
              setSelectedService(e)
            }}
            value={selectedService}
            className='customSelect'
            sub_category="tube"
          />
        </div>
      </div>

      {selectedService && (
        <div className='row'>
          <ReusableTable columns={columns} data={data?.data} />
        </div>
      )}
    </div>
  )
})

export default TubeReviewing
